import { urlBase, urlBaseImports } from "./config";
import axiosInstance from "../services/config/axiosinstance";

function getParticipantsLogistic({
  jwt,
  idEvent,
  offset,
  limit,
  search = "",
  status = "ATIVO",
  columnSearch = "",
}) {
  var config = {
    method: "get",
    url: `${urlBase}/events/${idEvent}/logistics/logins?offset=${offset}&limit=${limit}&search=${search}&status=${status}&columnSearch=${columnSearch}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function getParticipants({
  jwt,
  idEvent,
  offset,
  limit,
  search = "",
  status = "ATIVO",
  columnSearch = "",
}) {
  var config = {
    method: "get",
    url: `${urlBase}/login/loginbyevent/${idEvent}?offset=${offset}&limit=${limit}&search=${search}&status=${status}&columnSearch=${columnSearch}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

// Lista os participantes do evento já concatenados com as colunas dos
// formulários dinâmicos (relatório dinâmico do RSVP). Cada item vem com
// `dynamicValues: { [formId]: { createdAt, attributes: { [attributeId]: valor } } }`.
// `columns` são os attributeId escolhidos e `forms` os ids dos formulários —
// ambos vão como parâmetros repetidos e precisam ser encodados (os
// attributeId contêm acento, espaço e "?").
function getParticipantsDynamicColumns({
  idEvent,
  offset,
  limit,
  search = "",
  status = "ATIVO",
  columnSearch = "",
  columns = [],
  forms = [],
}) {
  const columnsQuery = columns
    .map((column) => `&columns=${encodeURIComponent(column)}`)
    .join("");

  const formsQuery = forms
    .map((formId) => `&forms=${encodeURIComponent(formId)}`)
    .join("");

  var config = {
    method: "get",
    url: `${urlBase}/login/loginbyevent/dynamic-columns/${idEvent}?offset=${offset}&limit=${limit}&search=${search}&status=${status}&columnSearch=${columnSearch}${columnsQuery}${formsQuery}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function getParticipantById(idEvent, loginId, offset, limit) {
  var config = {
    method: "get",
    url: `${urlBase}/login/loginbyevent/${idEvent}/event/${loginId}/participant?offset=${offset}&limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function getParticipantByQrCode(eventId, codeQr) {
  var config = {
    method: "get",
    url: `${urlBase}/login/loginbyqrcode/${eventId}/event/${codeQr}/qrcode`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function getLoginIdsToNotification({ jwt, offset, limit, data }) {
  var config = {
    method: "post",
    url: `${urlBase}/login/logintonotification/?offset=${offset}&limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}
function newParticipant({
  email,
  nome,
  senha,
  titleQrCode,
  codeQrCode,
  infoAcess,
  token,
  id_evento,
  grupos = [],
  empresa,
  cpf,
  telefone,
  cargo,
  interesseChat,
  codigoInterno1,
  codigoInterno2,
  codigoInterno3,
  restricaoHospedagem,
  idStatusRsvp,
}) {
  var data = JSON.stringify({
    email: email,
    nome: nome,
    senha: senha,
    foto: "",
    titleQrCode: titleQrCode,
    codeQrCode: codeQrCode,
    infoAcess: infoAcess,
    idEvento: id_evento,
    grupos: grupos,
    empresa: empresa,
    cpf: cpf,
    telefone: telefone,
    cargo: cargo,
    interesseChat: interesseChat,
    codigoInterno1: codigoInterno1,
    codigoInterno2: codigoInterno2,
    codigoInterno3: codigoInterno3,
    restricaoHospedagem: restricaoHospedagem,
    idStatusRsvp: idStatusRsvp,
  });
  var config = {
    method: "post",
    url: `${urlBase}/credentials`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function updateParticipant(data, token) {
  var config = {
    method: "post",
    url: `${urlBase}/login/updateuser`,
    headers: {
      "content-type": "multipart/form-data",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function updateParticipantV2(data) {
  var config = {
    method: "post",
    url: `${urlBase}/v2/login/updateuser`,
    headers: {
      "content-type": "application/json",
    },
    data: data,
  };

  try {
    const response = await axiosInstance(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
}

async function updateParticipantPassword(data) {
  var config = {
    method: "post",
    url: `${urlBase}/login/updateparticipantpassword`,
    headers: {
      "content-type": "application/json",
    },
    data: data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function deleteParticipant(id, token, eventId) {
  var config = {
    method: "delete",
    url: `${urlBase}/credentials/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: { idEvent: eventId },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function deleteAllParticipants({ jwt, eventId }) {
  var config = {
    method: "put",
    url: `${urlBase}/login/disableall/${eventId}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function uploadFile(data, token, event) {
  var config = {
    method: "post",
    url: `${urlBase}/login/uploadcsv/${event}`,
    headers: {
      "Content-Type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

function reactivateParticipant(event, login, token) {
  const data = {
    eventId: event,
    loginId: login,
  };
  var config = {
    method: "post",
    url: `${urlBase}/login/reactivate`,
    headers: {
      "content-type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function createParticipant(data, token) {
  const config = {
    method: "post",
    url: `${urlBaseImports}/credentials`,
    headers: {
      "content-type": "application/json",
    },
    data,
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      // if (error.response) {
      //   console.log(error.response.data);
      //   console.log(error.response.status);
      //   console.log(error.response.headers);
      // } else if (error.request) {
      //   console.log(error.request);
      // } else {
      //   console.log('Error', error.message);
      // }
      return error.response.data;
    });
}

async function verifyToDelete(eventId, userId) {
  var config = {
    method: "get",
    url: `${urlBase}/login/services/${eventId}/event/${userId}/login`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

async function verifyToDeleteAll(eventId) {
  var config = {
    method: "get",
    url: `${urlBase}/login/services/${eventId}/event`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export {
  getParticipantsLogistic,
  getParticipants,
  getParticipantsDynamicColumns,
  getParticipantById,
  getParticipantByQrCode,
  getLoginIdsToNotification,
  newParticipant,
  updateParticipant,
  updateParticipantPassword,
  deleteParticipant,
  deleteAllParticipants,
  reactivateParticipant,
  uploadFile,
  createParticipant,
  verifyToDelete,
  verifyToDeleteAll,
  updateParticipantV2,
};
